import React from 'react'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { BotFeatures, ChannelSchema } from '@feedyou-ai/feedbot-schema'

import { adjustUiSchemaForFormData } from './uiSchema'
import { SettingsPopup } from '../SettingsPopup'
import { useUserInfo } from '../../../store/user'
import { useSdkFeature } from '../../../store/app'
import { useOpenModalOpenSection } from '../../../store/modals/hooks/useOpenModalOpenSection'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { updateBotProperties } from '../../../actions/bot'
import {
  adjustSchema,
  adjustTelephonyChannelPropertiesForDialer,
  generateChannelsId
} from './utils'
import { useSettingsPopupState } from '../hooks'
import { useBotFlow } from '../../../store/flow'
import { STABLE_EMPTY_OBJECT } from '@feedyou/utils'

export const ChannelsSettingsPopup: React.FC = () => {
  const dispatch = useDispatch()
  const flow = useBotFlow()
  const user = useUserInfo()
  const openSection = useOpenModalOpenSection() ?? 'form'
  const isTelephonyAvailable = useSdkFeature(BotFeatures.TELEPHONY_CHANNEL_CONFIG)
  const isRealtimeAvailable = useSdkFeature(BotFeatures.REALTIME_CHANNEL)

  const { initialFormData, formData, onFormDataChange } = useSettingsPopupState(
    () => _.cloneDeep(flow!.channels || []),
    [openSection]
  )

  const close = () => dispatch(modalsActions.closeModal())

  return (
    <SettingsPopup
      className="no-error-panel"
      openSection={openSection}
      formData={formData}
      validationErrorsByField={STABLE_EMPTY_OBJECT}
      initialFormData={initialFormData}
      schema={adjustSchema(user, isTelephonyAvailable, isRealtimeAvailable)}
      uiSchema={adjustUiSchemaForFormData(formData as ChannelSchema[])}
      close={close}
      save={data => {
        dispatch(updateBotProperties({ channels: adjustTelephonyChannelPropertiesForDialer(data) }))
        close()
      }}
      onChange={(newFormData, isInitialPopulation) => {
        const adjustedFormData = generateChannelsId(newFormData)
        onFormDataChange(adjustedFormData, isInitialPopulation)
      }}
      validateSchema={(formData, errors) => {
        const items = Object.values(formData)
        const telephonyCount = items.filter((i: any) => i?.type === 'telephony').length

        if (telephonyCount <= 1) {
          return errors
        }

        errors.addError('A bot can only have one Telephony channel at a time')
        return errors
      }}
    />
  )
}
